import React from 'react';
import { Box, Typography, Fade } from '@mui/material';

/**
 * Status Message Banner Component
 * Displays temporary status messages with different types
 */
function StatusMessage({ message, type = 'info', position = 'top' }) {
  const getBackgroundColor = () => {
    switch (type) {
      case 'success':
        return 'rgba(46, 125, 50, 0.9)';
      case 'error':
        return 'rgba(211, 47, 47, 0.9)';
      case 'warning':
        return 'rgba(237, 108, 2, 0.9)';
      default:
        return 'rgba(0, 0, 0, 0.7)';
    }
  };

  const positionStyles = position === 'top' ? {
    top: 16,
    left: '50%',
    transform: 'translateX(-50%)',
  } : {
    bottom: 16,
    left: '50%',
    transform: 'translateX(-50%)',
  };

  return (
    <Fade in={!!message}>
      <Box
        sx={{
          position: 'absolute',
          ...positionStyles,
          backgroundColor: getBackgroundColor(),
          backdropFilter: 'blur(10px)',
          color: 'white',
          px: 3,
          py: 1.5,
          borderRadius: 2,
          zIndex: 70,
          boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
        }}
      >
        <Typography variant="body2">{message}</Typography>
      </Box>
    </Fade>
  );
}

export default StatusMessage;
